import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExternalUserCreationComponent } from './external-user-creation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ExternalEvaluationsService } from 'src/app/external-evaluation/external-evaluations.service';
import { PipesModule } from '../../pipes/pipes.module';
import { UtilService } from '../../services/util.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    PipesModule,
  ],
  declarations: [ExternalUserCreationComponent],
  providers: [
    ExternalEvaluationsService,
    UtilService
  ]
})
export class ExternalUserCreationModule { }
